


import {SystemDataVM} from './SystemDataVM';
export class LanguageVM extends SystemDataVM {
    
    isoCode?: string;
    
}
